
<div class="navbar-container row ">
    <div class="col-7 col-md-3 col-lg-3 col-xl-3 ">

        <img class="logo" [src]="logoPath" alt="Logo" [routerLink]="['/landing']" />

    </div>
    <div class="col-5 col-md-9 col-lg-9 col-xl-9 ">
      <div class="">
      <div class="d-md-flex d-sm-none justify-content-end">
<div class="d-md-flex d-sm-none" >
  <!-- <button mat-button class="text-white"[matMenuTriggerFor]="language">Language<em class="fa fa-angle-down ms-2" aria-hidden="true"></em></button>
  <mat-menu #language="matMenu" >
      <ng-container *ngFor="let lang of languages">
          <button mat-menu-item >
            {{ lang.title }}</button>
         
      </ng-container>
  </mat-menu> -->
      <div class="insurance-product-mat-menu" >
        <div>
          <button mat-button class="text-white" [matMenuTriggerFor]="insuranceProducts1">Get Quotes<em class="fa fa-angle-down ms-2" aria-hidden="true"></em></button>
          <mat-menu #insuranceProducts1="matMenu" >
              <ng-container *ngFor="let category of finalMaster">
                  <button mat-menu-item (click)="goToQuoteForm(category.mstGroupID)">
                    <em class="fa me-2" [ngClass]="{
                      'fa-heart-pulse' : category.mstGroupID == LOBEnum.health,
                      'fa-car' : category.mstGroupID == LOBEnum.motor,
                      'fa-solid fa-fire' : category.mstGroupID == LOBEnum.fireAndLightening,
                      'fa-solid fa-umbrella' : category.mstGroupID == LOBEnum.life,
                      'fa-solid fa-person' : category.mstGroupID == LOBEnum.workmen,
                      'fa-solid fa-location-dot' : category.mstGroupID == LOBEnum.travel,
                      'fa-solid fa-person-falling-burst' : category.mstGroupID == LOBEnum.groupPersonalAccident,
                      'fa-solid fa-wrench' : category.mstGroupID == LOBEnum.engineering
                  }" ></em>{{ category.pZLOB }}</button>
                   <!-- <mat-menu #menuTrigger="matMenu" [overlapTrigger]="false" [xPosition]="'after'" [yPosition]="'below'" [hasBackdrop]="false" [class]="'menu-' + category.mstGroupID">
                      <ng-container *ngFor="let subcat of category.subCategories">
                          <button mat-menu-item class="me-2" (click)="lobProduct(category.mstGroupID,subcat)">
                         {{ subcat.pZLOB }}</button>
                      </ng-container>
                  </mat-menu>  -->
              </ng-container>
          </mat-menu>
      </div>        
        </div>  
        <div>
        <button mat-button class="text-white"(click)="myPolicy()"> My Policy</button>

        </div>
           <div>
            <button mat-button class="text-white" (click)="myquotes()">My Quotation </button>
           </div>
        <!-- <div>
        <button mat-button class="text-white"[matMenuTriggerFor]="claimMenu" #claimMenuAppTrigger="matMenuTrigger">Claim<em class="fa fa-angle-down ms-2" aria-hidden="true"></em></button>
        <mat-menu #claimMenu="matMenu">
          <div (mouseleave)="claimMenuAppTrigger.closeMenu()">
          <ng-container *ngFor="let product of claimProducts">
            <button mat-menu-item [value]="product.value">
              {{ product.viewValue }}
            </button>
          </ng-container>
        </div>
        </mat-menu>
        </div> -->
  
        <!-- <div>
        <button mat-button class="text-white" [matMenuTriggerFor]="supportMenu" #supportMenuAppTrigger="matMenuTrigger">Support<em class="fa fa-angle-down ms-2" aria-hidden="true"></em></button>
        <mat-menu #supportMenu="matMenu">
          <div (mouseleave)="supportMenuAppTrigger.closeMenu()">
          <ng-container *ngFor="let product of supportProducts">
            <button mat-menu-item [value]="product.value">
              {{ product.viewValue }}
            </button>
          </ng-container>
        </div>
        </mat-menu>
        </div> -->
<div>  
    <div class="cus-mat-menu-panel">
      <div [hidden]="isLogin">
        <button mat-button class="text-white" (click)="loginPop()">
          <em class="fa fa-power-off me-2"></em>Login
        </button>
      </div>
      <div [hidden]="!isLogin">
      <button mat-button class="text-white" [matMenuTriggerFor]="profileMenu" #profileMenuAppTrigger="matMenuTrigger"  >
        <em class="fa fa-user-circle-o me-2" aria-hidden="true"></em> My Profile
      </button>
    
        <mat-menu #profileMenu="matMenu" >
          <div  class="p-4 pl-1">
            <div class="profile-info ">
               <div  >
                  <!-- <span class="name">{{userDetail?.fullName}}</span><br> -->
  
                  <span class="mem-id" *ngIf="userDetail?.userUniqueID">{{'Member_ID'|translate}}: <a href="javascript:void(0)"> <strong>{{
                          userDetail?.userUniqueID }}</strong> </a></span>
  
              </div> 
          </div>
          <ul class="profile-menu-list mb-0" (mouseleave)="profileMenuAppTrigger.closeMenu()">
              <li class="pointer" (click)="myPolicy()">
                  <em class="fas fa-sitemap"></em>
                  {{'My_Policy' | translate}}
              </li>
              <li  class="pointer" (click)="myquotes()">
                  <em class="fas fa-cog"></em>
                  {{'My_Quotation' | translate}}
              </li>
               <!-- <li  class="pointer">
                  <em class="fas fa-clock"></em>
                  {{'Cancel_Policy' | translate}}
              </li> 
              <li class="pointer">
                  <em class="fas fa-clock"></em>
                  {{'Renew_Policy' | translate}}
              </li> -->
              <li (click)="logout()" class="pointer">
                  <em class="fas fa-sign-out-alt"></em>
                  {{'LOGOUT' | translate}}
              </li>
          </ul>
          </div>
        </mat-menu>
      </div>
    </div>

      </div>
      </div>
    
      </div>
      </div>
 <div>
        <button mat-icon-button class="text-white" [matMenuTriggerFor]="mainMenu" class="d-lg-none d-md-none d-sm-flex float-right">
          <em class="fa fa-lg fa-bars text-white"></em>
        </button>
      </div>
    <mat-menu #mainMenu="matMenu" xPosition="before">
        <button mat-menu-item [matMenuTriggerFor]="insuranceMenu">Get Quotes</button>
        <!-- <button mat-menu-item [matMenuTriggerFor]="claimMenu">Claim</button> -->
        <button mat-menu-item [matMenuTriggerFor]="menuProfile">My Profile</button>
        <!-- <button mat-menu-item [matMenuTriggerFor]="language">Language</button> -->
 
    </mat-menu>
    <div class="d-none d-md-block d-sm-block" >

      <mat-menu #insuranceMenu="matMenu" xPosition="after" [hidden]="finalMaster.length==0"  >
          <ng-container *ngFor="let category of finalMaster">
              <button mat-menu-item (click)="goToQuoteForm(category.mstGroupID)">
                <em class="fa me-2" [ngClass]="{
                  'fa-heart-pulse' : category.mstGroupID == LOBEnum.health,
                  'fa-car' : category.mstGroupID == LOBEnum.motor,
                  'fa-solid fa-fire' : category.mstGroupID == LOBEnum.fireAndLightening,
                  'fa-solid fa-umbrella' : category.mstGroupID == LOBEnum.life,
                  'fa-solid fa-person' : category.mstGroupID == LOBEnum.workmen,
                  'fa-solid fa-location-dot' : category.mstGroupID == LOBEnum.travel,
                  'fa-solid fa-person-falling-burst' : category.mstGroupID == LOBEnum.groupPersonalAccident,
                  'fa-solid fa-wrench' : category.mstGroupID == LOBEnum.engineering
              }" ></em>{{ category.pZLOB }}</button>
               <mat-menu #menuTrigger="matMenu" [overlapTrigger]="false" [xPosition]="'after'" [yPosition]="'below'" [hasBackdrop]="false" [class]="'menu-' + category.mstGroupID">
                  <ng-container *ngFor="let subcat of category.subCategories">
                      <button mat-menu-item class="me-2">
                        <!-- <em class="fa me-2" [ngClass]="{
                          'fa-heart-pulse' : category.masterDataID == LOBEnum.health,
                          'fa-car' : category.masterDataID == LOBEnum.motor,
                          'fa-solid fa-fire' : category.masterDataID == LOBEnum.fireAndLightening,
                          'fa-solid fa-umbrella' : category.masterDataID == LOBEnum.life,
                          'fa-solid fa-person' : category.masterDataID == LOBEnum.workmen,
                          'fa-solid fa-location-dot' : category.masterDataID == LOBEnum.travel,
                          'fa-solid fa-person-falling-burst' : category.masterDataID == LOBEnum.groupPersonalAccident
                      }" ></em>-->
                      {{ subcat.pZLOB }}</button>
                  </ng-container>
              </mat-menu> 
          </ng-container>
      </mat-menu>
        <mat-menu #renewMenu="matMenu" xPosition="after" >
            <ng-container *ngFor="let product of renewProducts">
                <button mat-menu-item [value]="product.value">
                    {{ product.viewValue }}
                </button>
            </ng-container>
        </mat-menu>
        <mat-menu #claimMenu="matMenu" xPosition="after" >
            <ng-container *ngFor="let product of claimProducts">
                <button mat-menu-item [value]="product.value">
                    {{ product.viewValue }}
                </button>
            </ng-container>
        </mat-menu>
        <mat-menu #supportMenu="matMenu" xPosition="after" >
            <ng-container *ngFor="let product of supportProducts">
                <button mat-menu-item [value]="product.value">
                    {{ product.viewValue }}
                </button>
            </ng-container>
        </mat-menu>

        <mat-menu #menuProfile="matMenu" xPosition="after">
          <div class="menu-content" >
            <div class="menu-items">
              <div class="profile-info p-2" *ngIf="firstName">
                <!-- <img src="{{userDetail?.profilePictureURL}}" alt="Profile Picture"> -->
                <div>
                  <span class="name">{{firstName}}</span><br>
                  <!-- <span>{{'role'|translate}}: <strong>{{ userDetail?.roleName }}</strong></span><br> -->
                  <!-- <span>{{'Member_ID'|translate}}: <strong>{{ userDetail?.userUniqueID }}</strong></span> -->
                  <!-- <span>{{'Member_ID'|translate}}: <strong>{{ userDetail?.userUniqueID??'U-123ID' }}</strong></span> -->
                </div>
              </div>

              <ul class="profile-menu-list mb-0">
                <li class="pointer" mat-menu-item (click)="myPolicy()">
                    <em class="fas fa-sitemap"></em>
                    {{'My_Policy' | translate}} 
                </li>
                <li class="pointer" mat-menu-item (click)="myquotes()">
                    <em class="fas fa-cog"></em>
                    {{'My_Quotation' | translate}}
                </li>
                 <!-- <li class="pointer">
                    <em class="fas fa-clock"></em>
                   {{'Cancel_Policy' | translate}}
                </li>
               <li  class="pointer">
                    <em class="fas fa-clock"></em>
                   {{'Renew_Policy' | translate}}
                </li> -->
                <li [hidden]="isLogin" class="pointer" mat-menu-item (click)="loginPop()">
                    <em class="fas fa-power-off me-2"></em>Login
                </li>
                
                <li (click)="logout()" class="pointer" mat-menu-item [hidden]="!isLogin">
                    <em class="fas fa-sign-out-alt"></em>
                    {{'LOGOUT' | translate}}
                </li>
            </ul>
              <!-- <div class="logout">
                <i class="fa fa-power-off" (click)="logout()" aria-hidden="true"></i>&nbsp;
                <span class="" (click)="logout()">{{'LOGOUT'|translate}}</span>
              </div> -->
            </div>
          </div>
        </mat-menu>
        <!-- <mat-menu #language="matMenu" xPosition="after">
          <ng-container *ngFor="let lang of languages">
              <button mat-menu-item (click)="changeLanguage(lang.value)">=
                {{ lang.title }}</button>
             
          </ng-container>
      </mat-menu> -->

    </div>
    </div>
     
  </div>
   